export default "__VITE_ASSET__DE$sCW$m__"